module.exports = __webpack_public_path__ + "img/mk.301cf446.svg";